import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'vl-loading-state',
  templateUrl: './loading-state.component.html',
  styleUrls: ['./loading-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingStateComponent {
  @Input() description: string;
}
